<template>
  <div class="content-page main-width">
    <div class="title-logo-warp">
      <img :src="head || defaultHead" class="user-img">
      <span class="user-name">{{ name }}</span>
    </div>
    <a-spin :spinning="loading">
      <div class="body-content clearFloat">
        <div class="left">
          <div class="row" v-for="(value, key) in data.leader" :key="key">
            <div class="title" :style="{background:'#b80000'}">{{ matchFun.getLeaderName(key)}}</div>
            <div class="user-list">
              <div style="widht: 100px; display:inline-block;" v-for="(leader, index) in value" :key="'leader_' + index">
                <img :src="leader.image || defaultHead">
                <p style="text-align:center">{{ leader.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="row" v-for="(combat, index) in data.combats" :key="'combat_' + index">
            <div class="title" :style="{background:'#b80000'}">{{ combat.combatName }}<span>{{ combat.players.length }}人</span></div>
            <div class="user-list">
              <div style="widht: 100px; display:inline-block;" v-for="(player, playerIndex) in combat.players" :key="'player_' + playerIndex">
                <img :src="player.head || defaultHead">
                <p style="text-align:center">{{ player.name }} {{ player.weight ? player.weight + 'KG' : '' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'AgencyDetails',
  mounted () {
    // 初始化
    this.agencyJoinSimpleData()
  },
  created () {
  },
  data () {
    return {
      matchFun: matchFun,
      loading: false,
      defaultHead: require('../assets/photo.png'),
      matchId: this.$route.query.matchId,
      agencyId: this.$route.query.agencyId,
      type: this.$route.query.type,
      head: this.$route.query.head,
      name: this.$route.query.name,
      data: {combats: [], leader: null}
    }
  },
  methods: {
    agencyJoinSimpleData () {
      this.loading = true
      this.$api.match.agencyJoinSimpleData({matchId: this.matchId, agencyId: this.agencyId, type: this.type}).then(res => {
        this.loading = false
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-width {
  width:1200px;
  margin-left:auto;
  margin-right:auto;
}
.title-logo-warp{
  padding: 20px 0;
  padding-top: 40px;
  .user-img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  .user-name{
    color: #000;
    font-size: 20px;
    font-weight: bold;
    margin-left: 10px;
  }
  border-bottom: 1px solid #e8e8e8;
}
.body-content{
  padding: 30px 0;
  .left,.right{
    float: left;
  }
  .left{
    width: 35%;
    .title{
      width: 30% !important;
    }
  }
  .right{
    width: 60%;
    margin-left: 5%;
  }
  .row{
    .title{
      width: 70%;
      line-height: 40px;
      color: #fff;
      position: relative;
      font-size: 16px;
      padding: 0 20px;
      span{
        padding-left: 25px;
        margin-left: 25px;
        border-left: 1px solid #fff;
      }
      &::after{
        position: absolute;
        right: -14px;
        top: -4px;
        content: '';
        width: 50px;
        height: 60px;
        background-color: #ffffff;
        transform: rotate(25deg);
      }
    }
    .user-list{
      padding: 10px 0;
      img{
        width: 100px;
        height: 100px;
        margin: 10px;
        margin-left: 0;
        border-radius: 2px;
        border: 1px solid #fefefe;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchAgencyDetail.vue